import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdBrokerDealerSummary } from './types';

export const REGED_BROKER_DEALERS_QUERY_KEY = 'regEdBrokerDealers';

export const useRegEdBrokerDealersQuery = ({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [REGED_BROKER_DEALERS_QUERY_KEY, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IRegEdBrokerDealerSummary[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/brokerDealers',
				}),
				'GET'
			),
		meta: {
			toastErrorMessage: 'Failed to load broker-dealers.',
		},
	});
};
